export default class TrackingService {
    /**
     * @param timeout { duration for setTimeout if om not defined }
     */
    constructor(timeout) {
        this.queueActions = [];
        this.trackStateFired = false;

        /**
         * This parameter is introduced so trackState function call is not required in
         * derived classes. If certain tracking event is not firing, it is possible
         * to inherit from TrackingService class and set this variable to false.
         */
        this.requireFiredStateOnTracking = true;

        if (typeof timeout === 'number') {
            this.timeout = timeout;
        }
    }

    /**
     * @param actionName
     * @param payload
     */
    trackAction(actionName, payload = {}) {
        let makeCall = () => {
            try {
                if (typeof om === undefined) throw 'om is not loaded yet!';
                if (this.requireFiredStateOnTracking && !this.trackStateFired) {
                    this.queueActions.push(arguments);
                    return;
                }
                om.trackAction(actionName, payload);
            } catch (e) {
                this.onTrackingFail(e);
            }
        };

        if (typeof om !== 'undefined') {
            makeCall();
        } else if (this.timeout) {
            setTimeout(() => {
                this.trackAction(actionName, payload);
            }, this.timeout);
        }
    }

    trackLog(appLogType, appLogText = 'No message provided', appLogCode = 'No code provided') {
        this.trackAction('trackAppLog', {
            appLogText,
            appLogType,
            appLogCode
        });
    }

    /**
     * @param actionName
     * @param payload
     */
    trackState(payload = {}) {
        let makeCall = () => {
            try {
                if (typeof om === undefined) throw 'om is not loaded yet!';
                om.trackState(payload);
                this.trackStateFired = true;
                this.trackQueuedActions();
            } catch (e) {
                this.onTrackingFail(e);
            }
        };

        if (typeof om !== 'undefined') {
            makeCall();
        } else if (this.timeout) {
            setTimeout(() => {
                this.trackState(stateName, payload);
            }, this.timeout);
        }
    }

    trackQueuedActions() {
        this.queueActions.forEach((args) => {
            this.trackAction(...args);
        });
        // reset
        this.queueActions = [];
    }

    /**
     * @param e
     */
    onTrackingFail(e) {
        console.error(e);
    }
}
